import { useEffect, useState } from 'react';
import { useAuth } from '../state/auth';
import { RefreshIcon } from '../ui/icons';

interface Event {
  id: number;
  board_id: number;
  admin_id: number;
  action: string;
  criteria: any;
  stroke_ids: number[];
  created_at: string;
}

export function AuditLog() {
  const token = useAuth((s) => s.token)!;
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(false);

  async function reload() {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/events', {
        headers: { authorization: `Bearer ${token}` },
      });
      if (res.ok) setEvents(await res.json());
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    reload();
  }, []);

  async function rollback(id: number) {
    await fetch(`/api/admin/events/${id}/rollback`, {
      method: 'POST',
      headers: { authorization: `Bearer ${token}` },
    });
    reload();
  }

  return (
    <section className="bg-white rounded-xl border border-neutral-200 overflow-hidden">
      <div className="flex items-center justify-between px-5 py-3 border-b border-neutral-100">
        <div>
          <h3 className="text-[15px] font-semibold tracking-tight">擦除审计日志</h3>
          <p className="text-xs text-neutral-500 mt-0.5">{events.length} 条记录</p>
        </div>
        <button
          onClick={reload}
          disabled={loading}
          className="inline-flex items-center gap-1.5 h-8 px-2.5 rounded-md text-xs text-neutral-600 hover:bg-neutral-100 disabled:opacity-50"
        >
          <RefreshIcon size={14} />
          {loading ? '刷新中…' : '刷新'}
        </button>
      </div>
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="text-left text-[11px] uppercase tracking-wider text-neutral-500 bg-neutral-50 border-b border-neutral-100">
            <th className="px-5 py-2.5 font-medium">时间</th>
            <th className="px-5 py-2.5 font-medium">动作</th>
            <th className="px-5 py-2.5 font-medium text-right">Board</th>
            <th className="px-5 py-2.5 font-medium text-right">影响条数</th>
            <th className="px-5 py-2.5 font-medium"></th>
          </tr>
        </thead>
        <tbody>
          {events.map((e) => (
            <tr key={e.id} className="border-b border-neutral-100 last:border-none hover:bg-neutral-50/60">
              <td className="px-5 py-3 text-neutral-600 tabular-nums">
                {new Date(e.created_at).toLocaleString()}
              </td>
              <td className="px-5 py-3">
                <span className="inline-flex items-center rounded-md bg-neutral-100 px-2 py-0.5 text-[11px] font-medium text-neutral-700 font-mono">
                  {e.action}
                </span>
              </td>
              <td className="px-5 py-3 text-right tabular-nums text-neutral-600">{e.board_id}</td>
              <td className="px-5 py-3 text-right tabular-nums font-semibold text-neutral-800">
                {e.stroke_ids.length}
              </td>
              <td className="px-5 py-3 text-right">
                <button
                  onClick={() => rollback(e.id)}
                  className="h-7 px-2.5 rounded-md text-xs text-blue-700 hover:bg-blue-50"
                >
                  回滚
                </button>
              </td>
            </tr>
          ))}
          {events.length === 0 && (
            <tr>
              <td colSpan={5} className="px-5 py-10 text-center text-sm text-neutral-400">
                暂无记录
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </section>
  );
}
